define('modules/editor/models/landing_seo',['require','exports','module','backbone','../collections/custom_meta'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      CustomMetaCollection = require("../collections/custom_meta");

  var Serialization = {
    toJSON: function() {
      var json = module.exports.__super__.toJSON.apply(this);
      json.customMeta = this.customMeta.toJSON();
      return json;
    }
  };

  module.exports = Backbone.Model.extend({
    constructor: function(json, options) {
      this.customMeta = new CustomMetaCollection();
      module.exports.__super__.constructor.apply(this, arguments);
    },
    defaults: {
      title: "",
      keywords: "",
      description: "",
      robots: "",
      canonicalEnabled: "",
      canonicalURL: ""
    },
    getCustomMeta: function() {
      return this.customMeta.clone();
    },
    setCustomMeta: function(customMeta) {
      this.customMeta.reset(customMeta);
    },
    clone: function() {
      var clon = module.exports.__super__.clone.apply(this);
      clon.customMeta = this.customMeta.clone();
      return clon;
    },
    toJSON: Serialization.toJSON
  });
});

